import { getFullVariant } from '@wetransfer/transfer/modules/experiments';

export default class ExperimentTransferListExposeTeams {
  static key = 'transfer-list-workspace-bar';

  static variations = {
    control: 'false',
    'show-transfer-list-workspace-bar': 'show-transfer-list-workspace-bar',
  };

  static isControl(): boolean {
    return this.currentVariant() === this.variations.control;
  }

  static isExposeWorkspaceBarEnabled(): boolean {
    return (
      this.currentVariant() ===
      this.variations['show-transfer-list-workspace-bar']
    );
  }

  static currentVariant(): string {
    return getFullVariant(this.key, {
      value: this.variations['control'],
    }).value;
  }
}
